import { createSlice } from "@reduxjs/toolkit";
import { UpdateConsentConditionAsync, fetchConsentDataAsync } from "../thunks/ConsentThunk";
import { STATUS } from "./userDetailslice";

const initialConsentData: ConsentDetailsData = {
  consentDetails: null,
  status: STATUS.IDLE,
  loading: false,
  error: null,
  consentSubmitStatus: null,
  consentSubmitErrorMessage: null,
  consentDetailsStatus:STATUS.IDLE,
  consentDetailsErrorMessage:null,
};

interface ConsentDetailsData {
  consentDetails: Consent | null;
  status: string;
  loading: boolean;
  error: string | null;
  consentSubmitStatus: any;
  consentSubmitErrorMessage:any;
  consentDetailsStatus:string;
  consentDetailsErrorMessage:any;
}

export interface Consent {
  privacyPolicy: string | null;
  termsAndConditions: string | null;
}

const consentDetailsSlice = createSlice({
  name: "ConsentData",
  initialState: initialConsentData,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsentDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.consentDetailsStatus = STATUS.LOADING;
      })
      .addCase(fetchConsentDataAsync.fulfilled, (state, action) => {
        state.consentDetails = action.payload;
        state.consentDetailsStatus = STATUS.SUCCESS;
      })
      .addCase(fetchConsentDataAsync.rejected, (state, action) => {
        state.consentDetailsStatus = STATUS.FAILED;
        state.consentDetailsErrorMessage = action.error.message ?? null;
      })
      .addCase(UpdateConsentConditionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateConsentConditionAsync.fulfilled, (state, action) => {
        state.consentSubmitStatus = STATUS.SUCCESS;
        state.loading = false;
      })
      .addCase(UpdateConsentConditionAsync.rejected, (state, action) => {
        state.consentSubmitStatus = STATUS.FAILED;
        state.consentSubmitErrorMessage = action.error.message ?? null;
      });
  },
});

export default consentDetailsSlice.reducer;
